export const mutationTypes = {
    UPDATE_THE_MULTIPLICAND: 'UPDATE_THE_MULTIPLICAND',
    UPDATE_THE_MULTIPLICAND_TOTAL: 'UPDATE_THE_MULTIPLICAND_TOTAL',
    UPDATE_THE_MULTIPLICAND_PERCENTAGE: 'UPDATE_THE_MULTIPLICAND_PERCENTAGE',
    LOAD_FROM_SERVER: 'LOAD_FROM_SERVER',
    RESET: 'RESET',
};

// Initial State
const state = {
    periods: [],
    user: null,
    total: null,
    method: 'multiplicand_default',
    percentage: null,
};

// Getters
const getters = {
    total: state => state.total,
    determineTotal: state => state.user ? state.user : state.total,
    theMultiplicand: state => state,
};

// Actions
const actions = {
    adjustTheMultiplicand({ dispatch }, multiplicand) {
        const proms = Object.keys(multiplicand)
            .map(key => dispatch('adjustTheMultiplicandValue', { key, value: multiplicand[key] }));
        return Promise.all(proms);
    },
    adjustTheMultiplicandValue({ commit, state, dispatch }, { key, value }) {
        if (state[key] !== value) {
            commit(mutationTypes.UPDATE_THE_MULTIPLICAND, { key, value });
            return dispatch('fatal/dependency/updateTheMultiplicand', null, { root: true });
        }
    },
    updateTheValue({ commit, dispatch }, value) {
        commit(mutationTypes.UPDATE_THE_MULTIPLICAND_TOTAL, value);
        return dispatch('fatal/dependency/checkToUpdateMultipliers', null, { root: true });
    },
    loadFromServer({ commit }, payload) {
        commit(mutationTypes.LOAD_FROM_SERVER, payload);
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_THE_MULTIPLICAND](state, { key, value }) {
        state[key] = value;
    },
    [mutationTypes.UPDATE_THE_MULTIPLICAND_TOTAL](state, payload) {
        state.total = payload;
    },
    [mutationTypes.LOAD_FROM_SERVER](state, payload) {
        state.user = payload.user;
        state.total = payload.total;
        state.method = payload.method;
        state.percentage = payload.percentage;
    },
    [mutationTypes.RESET](state) {
        state.periods = [];
        state.user = null;
        state.total = null;
        state.method = 'multiplicand_default';
        state.percentage = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/fatal/dependency/multiplicand.js